import { Component, Input } from '@angular/core';
import { CompanyResponse, CompanySponsorResponse } from '../../../../../../@shared/models/response.module';
import { EndpointService } from '../../../../../../@shared/endpoints.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ToastService } from '../../../../../../@core/services/toast.service';

@Component({
  selector: 'app-add-company-sponsor',
  standalone: false,
  templateUrl: './add-company-sponsor.html',
  styleUrl: './add-company-sponsor.css'
})
export class AddCompanySponsor {
  @Input() company: CompanyResponse;
  @Input() editMode: boolean = false;
  @Input() companySponsor: CompanySponsorResponse | null = null;

  sponsor_name = '';
  sponsor_description = '';
  logoFile: File | null = null;

  saving = false;
  submitted = false;

  // Validation helpers
  get isSponsorNameInvalid(): boolean {
    return this.submitted && !this.sponsor_name.trim();
  }

  get isFormValid(): boolean {
    return !!this.sponsor_name.trim();
  }

  constructor(
    private endpointService: EndpointService,
    private modal: NgbActiveModal,
    private translateService: TranslateService,
    private toastService: ToastService
  ) {}

  ngOnInit() {
    if (this.editMode && this.companySponsor) {
      this.sponsor_name = this.companySponsor.sponsor?.sponsor_name || '';
      this.sponsor_description = this.companySponsor.sponsor?.sponsor_description || '';
    }
  }

  onSave() {
    this.submitted = true;

    if (!this.isFormValid) {
      this.toastService.error(this.translateService.instant('companyProfile.addSponsor.validationError'));
      return;
    }

    if (this.saving) return;
    this.saving = true;

    if (this.editMode && this.companySponsor) {
      // Update existing sponsor
      this.endpointService.cor_coy_22(this.companySponsor.entry_id, {
        company_id: this.company.company_id,
        sponsor_name: this.sponsor_name.trim(),
        sponsor_description: this.sponsor_description.trim()
      }).subscribe({
        next: (res) => {
          // Upload logo if provided
          if (this.logoFile && this.companySponsor) {
            this.endpointService.cor_coy_25(
              this.companySponsor.entry_id,
              this.company.company_id,
              this.logoFile
            ).subscribe({
              next: () => {
                this.saving = false;
                this.toastService.success(this.translateService.instant('companyProfile.addSponsor.updateSuccess'));
                this.modal.close(res.data);
              },
              error: () => {
                this.saving = false;
                this.toastService.success(this.translateService.instant('companyProfile.addSponsor.updateSuccess'));
                this.modal.close(res.data);
              }
            });
          } else {
            this.saving = false;
            this.toastService.success(this.translateService.instant('companyProfile.addSponsor.updateSuccess'));
            this.modal.close(res.data);
          }
        },
        error: (err) => {
          this.saving = false;
          this.toastService.error(err.error?.reason || this.translateService.instant('companyProfile.addSponsor.updateError'));
        }
      });
    } else {
      // Create new sponsor
      this.endpointService.cor_coy_21({
        company_id: this.company.company_id,
        sponsor_name: this.sponsor_name.trim(),
        sponsor_description: this.sponsor_description.trim()
      }).subscribe({
        next: (res) => {
          const newSponsor = res.data;
          // Upload logo if provided
          if (this.logoFile && newSponsor) {
            this.endpointService.cor_coy_25(
              newSponsor.entry_id,
              this.company.company_id,
              this.logoFile
            ).subscribe({
              next: () => {
                this.saving = false;
                this.toastService.success(this.translateService.instant('companyProfile.addSponsor.success'));
                this.modal.close(newSponsor);
              },
              error: () => {
                this.saving = false;
                this.toastService.success(this.translateService.instant('companyProfile.addSponsor.success'));
                this.modal.close(newSponsor);
              }
            });
          } else {
            this.saving = false;
            this.toastService.success(this.translateService.instant('companyProfile.addSponsor.success'));
            this.modal.close(newSponsor);
          }
        },
        error: (err) => {
          this.saving = false;
          this.toastService.error(err.error?.reason || this.translateService.instant('companyProfile.addSponsor.error'));
        }
      });
    }
  }

  close() {
    this.modal.close();
  }
}
